import { LegacyPublicationSection } from "models/interfaces/legacy-publication-section";
import { Record as ImmutableRecord } from "immutable";
import { RecordUtils } from "@rsm-hcd/javascript-core";
import { RouteUtils } from "utilities/route-utils";
import { siteMap } from "internal-sitemap";
import PublicationRecord from "./publication-record";
import { LegacyPublicationSectionRegionRecord } from "./legacy-publication-section-region-record";

const defaultValues: LegacyPublicationSection =
    RecordUtils.auditableDefaultValuesFactory<LegacyPublicationSection>({
        publicationId: undefined,
        publication: undefined,
        displayOrder: undefined,
        title: undefined,
        content: undefined,
        regions: undefined,
    });

export default class LegacyPublicationSectionRecord
    extends ImmutableRecord(defaultValues)
    implements LegacyPublicationSection
{
    constructor(params?: LegacyPublicationSection) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.publication != null) {
            params.publication = RecordUtils.ensureRecord(
                params.publication,
                PublicationRecord
            );
        }

        if (params.regions != null) {
            params.regions = params.regions.map((region) =>
                RecordUtils.ensureRecord(
                    region,
                    LegacyPublicationSectionRegionRecord
                )
            );
        }

        super(params);
    }

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------
    /**
     * Gets the full 'display' title of the Publication in the format of: NFPA {Code} {Title} ({Edition})
     * @example NFPA 70 - National Electric Code (2020)
     */
    public getDisplayTitle(): string {
        if (this.title == null || this.title.length === 0) {
            return "";
        }

        return this.title;
    }

    public getRoute(code: string, edition: string): string {
        const pageNumber = this.regions?.at(0)?.pageNumber ?? 1;

        return RouteUtils.getUrl(
            siteMap.publications.permalinks.legacyPublicationSectionPage,
            {
                code: code,
                edition: edition,
                pageNumber: pageNumber,
                sectionId: this.id,
            }
        );
    }
}
